import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import PageHeader from "../../components/common/PageHeader";
import { useXhr } from "hooks/useXhr";
import { useMessageContext } from "hooks/useMessageContext";
import { Button, Spinner } from "react-bootstrap";
import ReactQuill from 'react-quill';
import Quill from 'quill';
import 'react-quill/dist/quill.snow.css';

function Message() {
    //States
    const [status, setStatus] = useState(false);
    const [isUpdate, setIsUpdate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [lang, setLang] = useState(null);
    const [error, setError] = useState({
        field: null,
        note: null
    });

    //Hooks
    const { customXhr } = useXhr()
    const { message1, dispatch } = useMessageContext();

    //Quill Config
    const SizeStyle = Quill.import("attributors/style/size");
    SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '24px', '32px', '48px'];
    Quill.register(SizeStyle, true);

    const AlignStyle = Quill.import("attributors/style/align");
    Quill.register(AlignStyle, true);

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'size': ['12px', '14px', '16px', '18px', '24px', '32px', '48px'] }],
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link'],
            ['clean'],
            [{ 'color': [] }, { 'background': [] }]
        ]
    }

    //Constants
    const requiredFields = ['alt1', 'alt2', 'text1'];

    //Functions
    const handleOnChange = (e) => {
        const { id, value } = e.target;

        setIsUpdate(prevState => ({
            ...prevState,
            [id]: value
        }));
    };

    const handleTextInput = (e, field) => {
        setIsUpdate(prevState => ({
            ...prevState,
            [field]: e
        }));
    };

    const generateUniqueFileName = (file) => {
        const timestamp = Date.now();
        const randomNumber = Math.floor(Math.random() * 10000);
        const extension = file.name.split('.').pop();

        return `${timestamp}_${randomNumber}.${extension}`;
    };

    const handlePhotoInput = (e) => {
        const file = e.target.files[0];
        const id = e.target.id;

        const newFileName = generateUniqueFileName(file);
        const renamedFile = new File([file], newFileName, { type: file.type });

        setIsUpdate(prevState => ({
            ...prevState,
            [id]: renamedFile
        }));
    };

    const handleSubmit = async () => {
        for (const field of requiredFields) {
            if (!isUpdate[field] || isUpdate[field] === "") {
                return (
                    setError({
                        field: field,
                        note: `Zorunlu alan`
                    }),
                    setIsLoading(false)
                )
            }
        }
        setIsLoading(true);
        const formData = new FormData();
        formData.append('module', 'message1');
        formData.append('action', 'update');
        formData.append('id', isUpdate.id);
        formData.append('firstPhoto', isUpdate.firstPhoto);
        formData.append('secondPhoto', isUpdate.secondPhoto);
        formData.append('alt1', isUpdate.alt1);
        formData.append('alt2', isUpdate.alt2);
        formData.append('text1', isUpdate.text1);
        formData.append('textEng', isUpdate.textEng);
        formData.append('textFra', isUpdate.textFra);
        formData.append('textGer', isUpdate.textGer);
        formData.append('textDut', isUpdate.textDut);

        const response = await customXhr(formData);

        if (response.status === "success") {
            setIsUpdate(null);
            setLang(null);
            setStatus(!status);
            setError({
                field: null,
                note: null
            });
            setIsLoading(false);
        };
    };

    const getMessage = async () => {
        const formData = new FormData();
        formData.append('module', 'message1');
        formData.append('action', 'list');

        const response = await customXhr(formData);

        if (response) {
            dispatch({ type: 'SET_MESSAGE', payload: response[0] });
        };
    };

    useEffect(() => {
        getMessage();
    }, [status]);

    return (
        <div className="container-xxl">
            <PageHeader headerTitle="Yönetim Kurulu Başkanı Mesajı" renderRight={() => {
                return <div className="btn-group" role="group" aria-label="Basic outlined example">
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Türkçe Güncelleme"
                        onClick={() => { setIsUpdate(message1); setLang("tur"); }}
                    >
                        <i className="icofont-edit text-success"></i>
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="İngilizce Güncelleme"
                        onClick={() => { setIsUpdate(message1); setLang("eng"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/united-kingdom.png`} style={{ width: "15px" }} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Fransızca Güncelleme"
                        onClick={() => { setIsUpdate(message1); setLang("fra"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/france.png`} style={{ width: "15px" }} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Almanca Güncelleme"
                        onClick={() => { setIsUpdate(message1); setLang("ger"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/germany.png`} style={{ width: "15px" }} />
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        title="Felemenkçe Güncelleme"
                        onClick={() => { setIsUpdate(message1); setLang("dut"); }}
                    >
                        <img src={process.env.PUBLIC_URL + `/flags/netherlands.png`} style={{ width: "15px" }} />
                    </button>
                </div>
            }} />
            <div className="row align-items-center justify-content-center">
                <div className="col-xxl-10 col-xl-12 col-lg-12 col-md-12 flex-column">
                    {message1 &&
                        <>
                            <div className="card">
                                <div className="card-body">
                                    <div className="g-2 pt-4">
                                        <div style={{ width: "100%" }}>
                                            <div
                                                style={{
                                                    float: "right",
                                                    width: "25%",
                                                    marginLeft: "150px",
                                                    marginBottom: "20px"
                                                }}
                                            >
                                                <img
                                                    src={process.env.PUBLIC_URL + `/uploads/message1/${message1.firstPhotoName}`}
                                                    style={{
                                                        width: "100%",
                                                        objectFit: "cover",
                                                        marginBottom: "36px"
                                                    }}
                                                />
                                                <img
                                                    src={process.env.PUBLIC_URL + `/uploads/message1/${message1.secondPhotoName}`}
                                                    style={{
                                                        width: "100%",
                                                        objectFit: "cover"
                                                    }}
                                                />
                                            </div>
                                            <div dangerouslySetInnerHTML={{ __html: message1.text1 }} />
                                        </div>

                                    </div>
                                    <div className="row g-2 pt-4">
                                        <div className="col-12">
                                            <div className="d-flex align-items-center">
                                                <div className="text-primary">{"SEO 1 => "}</div>
                                                <span className="ms-2">{message1.alt1}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row g-2 pt-4">
                                        <div className="col-12">
                                            <div className="d-flex align-items-center">
                                                <div className="text-primary">{"SEO 2 => "}</div>
                                                <span className="ms-2">{message1.alt2}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
            <Modal
                show={lang === "tur"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Kalitenin Reis'i Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="text1" className="form-label">
                            {"Yazı"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="text1"
                                value={isUpdate.text1}
                                onChange={(e) => handleTextInput(e, "text1")}
                                style={{ borderColor: `${error.field === "text1" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "text1" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                    <div className="mb-3">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="alt1" className="form-label">
                                    {"Seo Kelimeler "}
                                    <span className="text-danger">
                                        (Lütfen 5 Kelimeden Fazla Yazmayınız!)
                                    </span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="alt1"
                                    value={isUpdate && isUpdate.alt1}
                                    onChange={handleOnChange}
                                    style={{ borderColor: `${error.field === "alt1" ? "red" : "var(--border-color)"}` }}
                                />
                                {error.field === "alt1" &&
                                    <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                                }
                            </div>
                            <div className="col-6">
                                <label htmlFor="alt2" className="form-label">
                                    {"Seo Kelimeler "}
                                    <span className="text-danger">
                                        (Lütfen 5 Kelimeden Fazla Yazmayınız!)
                                    </span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="alt2"
                                    value={isUpdate && isUpdate.alt2}
                                    onChange={handleOnChange}
                                    style={{ borderColor: `${error.field === "alt2" ? "red" : "var(--border-color)"}` }}
                                />
                                {error.field === "alt2" &&
                                    <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="row">
                            <div className="col-6">
                                <label htmlFor="firstPhoto" className="form-label">
                                    {"1.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="firstPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 700x870"}
                                </div>
                            </div>
                            <div className="col-6">
                                <label htmlFor="secondPhoto" className="form-label">
                                    {"2.Fotoğraf Yükle"}
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="secondPhoto"
                                    onChange={handlePhotoInput}
                                />
                                <div className="form-label" style={{ color: "red" }}>
                                    {"Bu alanın geçerli görsel öğe boyutu: 730x1000"}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "eng"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">İngilizce Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textEng" className="form-label">
                            {"Yazı"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textEng"
                                value={isUpdate.textEng}
                                onChange={(e) => handleTextInput(e, "textEng")}
                                style={{ borderColor: `${error.field === "textEng" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textEng" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "fra"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Fransızca Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textFra" className="form-label">
                            {"Yazı"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textFra"
                                value={isUpdate.textFra}
                                onChange={(e) => handleTextInput(e, "textFra")}
                                style={{ borderColor: `${error.field === "textFra" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textFra" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "ger"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Almanca Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textGer" className="form-label">
                            {"Yazı"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textGer"
                                value={isUpdate.textGer}
                                onChange={(e) => handleTextInput(e, "textGer")}
                                style={{ borderColor: `${error.field === "textGer" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textGer" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={lang === "dut"}
                onHide={() => {
                    setIsUpdate(null);
                    setLang(null);
                    setError({
                        field: null,
                        note: null
                    });
                    setIsLoading(false);
                }}
                dialogClassName="modal-xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Felemenkçe Düzenle</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <label htmlFor="textDut" className="form-label">
                            {"Yazı"}
                        </label>
                        {isUpdate &&
                            <ReactQuill
                                theme="snow"
                                id="textDut"
                                value={isUpdate.textDut}
                                onChange={(e) => handleTextInput(e, "textDut")}
                                style={{ borderColor: `${error.field === "textDut" ? "red" : "var(--border-color)"}` }}
                                modules={modules}
                            />}
                        {error.field === "textDut" &&
                            <label className="form-label" style={{ color: "red" }}>{error.note}</label>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        className="me-1"
                        onClick={() => handleSubmit()}
                        disabled={isLoading}
                    >
                        {
                            isLoading ?
                                <>
                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />
                                    Yükleniyor...
                                </> :
                                <>
                                    Kaydet
                                </>
                        }
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Message;